export default {
  login: {
    method: 'post',
    url: '/auth/token'
  },
  logout: {
    method: 'post',
    url: '/auth/user/logout'
  },
  register: {
    method: 'post',
    url: '/auth/register',
    headers: {
      tokenInvite: ''
    }
  },
  forgotPassword: {
    method: 'post',
    url: '/auth/forgot-password'
  },
  resetPassword: {
    method: 'post',
    url: '/auth/reset-password'
  },
  resetPasswordConfirm: {
    method: 'post',
    url: '/auth/reset-password-confirm'
  },
  changePassword: {
    method: 'put',
    url: 'auth/user/change-password'
  },
  acceptInvitation: {
    method: 'post',
    url: 'auth/invite/accept'
  }
}
